/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Total/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Total({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/CustomPlan/MaxLength/Info/Total"
  
}) {
let dtTypographyFontsizeXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.xs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Total length of the payment plan in months"
 fontSize={dtTypographyFontsizeXs}
 marginTop={dtSpaceXs}
 marginLeft={dtSpaceXxs}
/>
{children}
</React.Fragment>)
}